<template>
    <div class="vagary-phone-decryption">
        <el-tooltip class="item" effect="dark" content="点我复制真实手机号" placement="top">
            <i class="el-icon-document-copy" style="color: #409EFF;margin-left:0.1rem;cursor:pointer"
                @click="getRealPhone"></i>
        </el-tooltip>
    </div>
</template>
<script>
import { common } from '../../static/mixins/common'
export default {
    name: 'VagaryPhoneDecryption',
    mixins: [common],
    props: {
        vagary_phone: {
            type: String
        }
    },
    data() {
        return {

        };
    },

    mounted() {

    },
    watch: {

    },

    methods: {
        getRealPhone() {
            this.$axios.get('api/phone_decrypt', {
                params: {
                    phone: this.vagary_phone
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyCopySome(data.phone)
                } else {
                    this.$message.warning(data.msg)
                }
            }).catch()
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/common/VagaryPhoneDecryption.vue